export const allowedKeys = (event: any) => {
  const key = event.keyCode || event.which;
  let keyAllowed = false;

  // Allow: backspace, delete, tab, escape, enter
  if (key === 8 || key === 46 || key === 9 || key === 27 || key === 13) {
    keyAllowed = true;
  }

  // Allow: Ctrl+A, Command+A, Ctrl+V, Command+V
  if (
    (event.ctrlKey === true || event.metaKey === true) &&
    (key === 65 || key === 97 || key === 86 || key === 118)
  ) {
    keyAllowed = true;
  }

  // Allow: home, end, left, right, down, up
  if (
    key === 35 ||
    key === 36 ||
    key === 37 ||
    key === 39 ||
    key === 40 ||
    key === 38
  ) {
    keyAllowed = true;
  }

  return keyAllowed;
};

export const checkSpecialCharToFrom = (e: any) => {
  if (allowedKeys(e)) return;
  const allowedCharacters = /^[A-Za-zÀ-ÖØ-öø-ÿ' .-]+$/;
  if (!allowedCharacters.test(e.key)) {
    e.preventDefault();
  }
};

export const checkSpecialCharMessage = (e: any) => {
  if (allowedKeys(e)) return;
  const allowedCharacters = /^[0-9A-Za-zÀ-ÖØ-öø-ÿ' ,#()/.$%&@*!/?+=_:;"\\-]+$/;
  if (!allowedCharacters.test(e.key)) {
    e.preventDefault();
  }
};

export const checkSpecialCharEmail = (e: any) => {
  if (allowedKeys(e)) return;
  const allowedCharacters = /^[a-zA-Z0-9@._+-]$/;
  if (!allowedCharacters.test(e.key)) {
    e.preventDefault();
  }
};

export const numbersOnly = (e: any) => {
  if (allowedKeys(e)) return;
  const allowedCharacters = /^[\d]+$/;
  if (!allowedCharacters.test(e.key)) {
    e.preventDefault();
  }
};

export const validationFunction = (type: string): any => {
  if (type === 'text') return checkSpecialCharToFrom;
  else if (type === 'tel') return numbersOnly;
  else if (type === 'email') return checkSpecialCharEmail;

  return () => {};
};
